/* eslint-disable */
import md5 from 'js-md5'

export function getRem(n) {
  let e, t, i, d, o, a
  e = n.document
  t = e.documentElement
  i = 640
  d = i / 100
  o = 'orientationchange' in n ? 'orientationchange' : 'resize'
  a = () => {
    let n = t.clientWidth || 320; n > 640 && (n = 640)
    t.style.fontSize = `${n / d}px`
  }
  if (e.addEventListener) {
    n.addEventListener(o, a, !1)
    e.addEventListener('DOMContentLoaded', a, !1)
  }
}

export const ldb = {
  // 获取
  read: key => JSON.parse(window.localStorage.getItem(key)),
  // 设置
  save: (key, val) => window.localStorage.setItem(key, JSON.stringify(val)),
  // 删除
  remove: key => window.localStorage.removeItem(key)
}

// 登录接口延签
export function getSign(params) {
  const ucentKey = 'HitTEWfyAERMrYXo$s2iSYgB8!urBUv#'
  var arr = []
  for (var i in params) {
    arr.push((i + '=' + params[i]))
  }
  var paramsStr = arr.join(('&'))
  var urlStr = paramsStr.split('&').sort().join('&')
  // 签名前 添加 timestamp  有则添加  没有则空串
  var newUrl = urlStr + '&timestamp=&key=' + ucentKey
  return md5(newUrl).toUpperCase()
}

// 生成设备唯一标识
export function setUuid() {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  var uuid = s.join('')
  return uuid
}

export const getAge = (str) => {
  // eslint-disable-next-line no-useless-escape
  const birthday = new Date(str.replace(/-/g, "\/"))
  const d = new Date()
  const age = d.getFullYear() - birthday.getFullYear() - ((d.getMonth() < birthday.getMonth() || d.getMonth() == birthday.getMonth() && d.getDate() < birthday.getDate()) ? 1 : 0)
  return age
}

export const reload = () => {
  const u = navigator.userAgent
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  if (isIOS) {
    // 这个是ios操作系统
    const notFirstInvite = sessionStorage.getItem('not_first_invite')
    if (!notFirstInvite) {
      sessionStorage.setItem('not_first_invite', '1')
      window.location.reload()
    }
  }
}

export const isIOS = () => {
  let isIphone = navigator.userAgent.includes('iPhone')
  let isIpad = navigator.userAgent.includes('iPad')
  return isIphone || isIpad
}


export const isMobile = () => {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}

export const changeCertImg = (name) => {
  switch (name) {
    case "儿童言语治疗师高级证书":
      return "YYZLS";
    case "ABA高级行为干预师证书":
      return "ABAXWGYS";
    case "儿童感统治疗师高级证书":
      return "GTZLS";
    case "VB评估高级技能证书":
      return "VBPGZS";
    case "执行功能高级证书":
      return "ZXGNGJZS";
    case "言语治疗国际课证书":
      return "YYGJKZS";
    case "语音障碍训练营证书":
      return "YYXLYZS";
    case "语言行为训练营证书":
      return "YYXWXLYZS";
    case "游戏技能训练营证书":
      return "YXXLYZS";
    case "孤独症从业规范证书":
      return "CYGFZS";
    default:
      break;
  }
}


// WEBPACK FOOTER //
// ./src/utils/validate.js